var filter = (function() {
  var durationTrans = function(dv, fStr) {
    var transHash = {
      day: window.Vue.t('common.day'),
      hour: window.Vue.t('common.hour'),
      minute: window.Vue.t('common.minute'),
      second: window.Vue.t('common.second')
    };
    var dObj = {
      sortArr: [],
      maxUnit: 1,
      minUnit: 4,
      config: {
        day: {
          v: 0,
          pushed: false,
          transKey: 'day',
          aStr: 'days',
          fStr: '',
          unit: 4
        },
        hour: {
          v: 0,
          pushed: false,
          transKey: 'hour',
          aStr: 'hours',
          fStr: '',
          unit: 3
        },
        minute: {
          v: 0,
          pushed: false,
          transKey: 'minute',
          aStr: 'minutes',
          fStr: '',
          unit: 2
        },
        second: {
          v: 0,
          pushed: false,
          transKey: 'second',
          aStr: 'seconds',
          fStr: '',
          unit: 1
        }
      }
    };
    fStr.split('').map(function(v, i) {
      var initConfigData;
      switch (v) {
        case 'D':
          initConfigData = dObj.config.day;
          break;
        case 'H':
          initConfigData = dObj.config.hour;
          break;
        case 'm':
          initConfigData = dObj.config.minute;
          break;
        case 's':
          initConfigData = dObj.config.second;
          break;
      }
      if (initConfigData) {
        if (initConfigData.pushed === false) {
          dObj.sortArr.push(initConfigData);
          initConfigData.pushed = true;
          if (initConfigData.unit > dObj.maxUnit) {
            dObj.maxUnit = initConfigData.unit;
          }
          if (initConfigData.unit < dObj.minUnit) {
            dObj.minUnit = initConfigData.unit;
          }
        }
        initConfigData.fStr += v;
      }
    });
    if (dObj.maxUnit === 4 && dv < 24 * 60 * 60 * 1000 && dObj.minUnit < 4) {
      dObj.maxUnit = 3;
    }
    if (dObj.maxUnit === 3 && dv < 60 * 60 * 1000 && dObj.minUnit < 3) {
      dObj.maxUnit = 2;
    }
    if (dObj.maxUnit === 2 && dv < 60 * 1000 && dObj.minUnit < 2) {
      dObj.maxUnit = 1;
    }
    if (dObj.minUnit > dObj.maxUnit) {
      dObj.minUnit = dObj.maxUnit;
    }
    var dStr = '';
    dObj.sortArr.map(function(v, i) {
      var vStr;
      if (v.unit === dObj.maxUnit) {
        vStr = Math.floor(moment.duration(dv).as(v.aStr)) + '';
      } else if (v.unit < dObj.maxUnit && v.unit >= dObj.minUnit) {
        vStr = moment.utc(dv).format(v.fStr);
      }/* else if (v.unit === dObj.minUnit) {
        vStr = moment.utc(dv).format(v.fStr);
      }*/
      if (parseInt(vStr) || (dStr === '' && v.unit === dObj.minUnit)) {
        dStr += vStr + transHash[v.transKey];
      }
    });
    return dStr;
  };
  var momentFormat = function(value, formatStr, formatType) {
    switch (formatType) {
      case undefined:
        return moment(value).format(formatStr) + (moment(value).isDST() && formatStr.indexOf('HH') >= 0 ? '(DST)' : '');
        break;
      case 'duration':
      case 'durationHumanize':
        if (value < 0) {
          value = -value;
        }
        return durationTrans(value, formatStr);
        break;
    }
  };
  return momentFormat;
})();

export default filter;
